import React from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { SpecialOffersProps } from './FairDetail.types'
import { getPrimaryColor } from '../../style/utils'
import { ImageComponent } from '../../components/ui-elements/Image'
import { dateToStringWithSlash } from 'crm/function/dateFunctions'

export const BridalSpecialOffers: React.FC<SpecialOffersProps> = (props) => {
  return <StyledPage {...props} />
}

const Page: React.FC<SpecialOffersProps> = ({
  className,
  // primaryColor,
  bridalSpecialOffers,
}) => {
  const sortByBridalSpecialOffers = bridalSpecialOffers.map((offer, index) => ({ ...offer, index }))

  sortByBridalSpecialOffers.sort((a, b) => {
    if (a.applicableType === b.applicableType) {
      return a.index - b.index
    }
    return a.applicableType === '成約特典' ? -1 : 1
  })

  const orderByBridalSpecialOffers = sortByBridalSpecialOffers.map((offer) => {
    const { index, ...orderdOffer } = offer
    return orderdOffer
  })

  return (
    <div className={className}>
      {orderByBridalSpecialOffers.map((specialOffer, index) => {
        return (
          <div className="special-offer-card" key={index}>
            <div className="top-card">
              {specialOffer.mainImageData && (
                <div className="main-image-wrapper">
                  <ImageComponent
                    imageData={specialOffer.mainImageData}
                    aspectRatio={'oneToOneImage'}
                    altText={specialOffer.name}
                    className="main-image"
                  />
                </div>
              )}
              <div className="detail-wrapper">
                <div className="name">{specialOffer.name}</div>
                <div className="applicable-type">
                  <span className="applicable-type-wrap">{specialOffer.applicableType}</span>
                </div>
                <div className="applicable-date">
                  対象期間：
                  {specialOffer.applicableType === '来館特典'
                    ? `${specialOffer.applicableFirstVisitStartDate ? dateToStringWithSlash(specialOffer.applicableFirstVisitStartDate, 'long') : ''
                      }〜${
                        specialOffer.applicableFirstVisitEndDate
                          ? dateToStringWithSlash(specialOffer.applicableFirstVisitEndDate, 'long')
                          : ''
                      }`
                    : specialOffer.applicableType === '成約特典'
                      ? `${specialOffer.applicableContractStartDate ? dateToStringWithSlash(specialOffer.applicableContractStartDate, 'long') : ''
                        }〜${
                          specialOffer.applicableContractEndDate
                            ? dateToStringWithSlash(specialOffer.applicableContractEndDate, 'long')
                            : ''
                        }`
                      : null}
                </div>
              </div>
            </div>
            <div className="bottom-card">
              <div className="description-wrapper">
                <pre className="description-text">{specialOffer.descriptionText}</pre>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

const StyledPage = styled(Page)`
  display: flex;
  flex-wrap: wrap;

  > .special-offer-card {
    width: calc(50% - 4px);
    max-width: 476px;
    padding: 24px;
    margin-right: 8px;
    margin-bottom: 8px;
    flex-direction: column;
    display: flex;
    border: 2px solid ${styleTheme.colors.gray.light};
    border-radius: 8px;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0;
    }

    > .top-card {
      display: flex;

      > .main-image-wrapper {
        max-height: 120px;
        margin-right: 16px;

        > .main-image {
          width: 120px;
          height: 120px;
          object-fit: cover;
          object-position: center;
        }
      }

      > .detail-wrapper {
        max-width: 280px;

        > .name {
          margin-bottom: 12px;
          color: ${styleTheme.colors.black};
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 150%; /* 24px */
          letter-spacing: 0.48px;
        }

        > .applicable-type {
          margin-bottom: 4px;

          > span.applicable-type-wrap {
            padding: 2px 8px;
            color: ${getPrimaryColor};
            font-family: Noto Sans JP;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            border-radius: 2px;
            border: 1px solid ${getPrimaryColor};
          }
        }

        > .applicable-date {
          color: ${styleTheme.colors.black};
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 21px */
          letter-spacing: 0.42px;
        }
      }
    }

    > .bottom-card {
      margin-top: 16px;

      > .description-wrapper {
        > pre {
          margin: 0;
        }

        > .description-text {
          white-space: pre-wrap;
          color: ${styleTheme.colors.black};
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          letter-spacing: 0.42px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    > .special-offer-card {
      width: 100%;
      height: 100%;
      max-width: none;
      max-height: none;
      margin-right: 0;

      > .top-card {
        > .main-image-wrapper {
          max-height: none;
          display: flex;
          justify-content: center;
          align-items: center;

          > .main-image {
            width: 100%;
            max-width: 120px;
            height: auto;
          }
        }

        > .detail-wrapper {
          max-width: none;
        }
      }
    }
  }
`
